import api from './api';
import type { Notification } from '../types';

export const notificationService = {
  // Scope the count to one type (e.g. `{ type: 'lead' }` for the Leads nav
  // badge), or exclude one (`{ excludeType: 'lead' }` for the bell, which
  // already hides lead notifications from its own dropdown). Omit both to
  // get the total unread count across every type.
  getUnreadCount: async (params?: { type?: string; excludeType?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.type) searchParams.append('type', params.type);
    if (params?.excludeType) searchParams.append('excludeType', params.excludeType);
    const qs = searchParams.toString();
    const response = await api.get(`/api/notifications/unread-count${qs ? `?${qs}` : ''}`);
    return response.data.data.count as number;
  },

  getRecent: async (limit = 10) => {
    const response = await api.get(`/api/notifications?limit=${limit}`);
    return response.data.data.notifications as Notification[];
  },

  markAsRead: async (id: string) => {
    await api.patch(`/api/notifications/${id}/read`);
  },

  markAllAsRead: async () => {
    await api.post('/api/notifications/mark-all-read');
  },

  markReadByType: async (type: string) => {
    await api.post('/api/notifications/mark-read-by-type', { type });
  },
};
